import httpClient from "./httpClient";

export async function listarConcorrentes() {
  const resp = await httpClient.get("/api/concorrentes");
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function criarConcorrente(concorrente) {
  const resp = await httpClient.post("/api/concorrentes", concorrente);
  return resp.data;
}

export async function atualizarConcorrente(id, concorrente) {
  const resp = await httpClient.put(`/api/concorrentes/${id}`, concorrente);
  return resp.data;
}

export async function removerConcorrente(id) {
  await httpClient.delete(`/api/concorrentes/${id}`);
}
